import { convertImageFromDto } from "@modules/dtos/imageDto"
import { ProfileTypeOf } from "@modules/profile/profileTypes"
import { FavoritePersonalRecordEntity } from "@modules/profile/publicProfile/entities/favoritesPersonalRecord"
import { UserBadgeEntity } from "@modules/profile/publicProfile/entities/userBadgeEntity"
import { type PublicProfileDto } from "@modules/profile/publicProfile/gateway/publicProfileDto"
import { ProgramBundleItemEntity } from "@modules/programBundle/entities/programBundleEntity"
import { UserProgramItemEntity } from "@modules/programs/entities/userProgramItemEntity"
import { type HUImage } from "@modules/types/imageTypes"

export class PublicProfileEntity {
  userId: string
  _type: typeof ProfileTypeOf
  username: string
  firstname: string | null
  lastname: string | null
  biography: string | null
  avatar: HUImage | null
  birthDate: Date | null
  crossfitStartDate: string | null
  genderCategory: string | null
  job: string | null
  nationality: string | null
  height: number | null
  weight: number | null
  favoritesPersonalRecords: FavoritePersonalRecordEntity[]
  followedProgramBundle: ProgramBundleItemEntity[]
  ownedPrograms: UserProgramItemEntity[]
  followedPrograms: UserProgramItemEntity[]
  sharedCoachPrograms: UserProgramItemEntity[]
  badges: UserBadgeEntity[]

  private constructor(entity: PublicProfileEntity) {
    this.userId = entity.userId
    this._type = entity._type
    this.username = entity.username
    this.firstname = entity.firstname
    this.lastname = entity.lastname
    this.biography = entity.biography
    this.avatar = entity.avatar
    this.birthDate = entity.birthDate
    this.crossfitStartDate = entity.crossfitStartDate
    this.genderCategory = entity.genderCategory
    this.job = entity.job
    this.nationality = entity.nationality
    this.height = entity.height
    this.weight = entity.weight
    this.favoritesPersonalRecords = entity.favoritesPersonalRecords
    this.followedProgramBundle = entity.followedProgramBundle
    this.ownedPrograms = entity.ownedPrograms
    this.followedPrograms = entity.followedPrograms
    this.sharedCoachPrograms = entity.sharedCoachPrograms
    this.badges = entity.badges
  }

  static fromDto(dto: PublicProfileDto): PublicProfileEntity {
    return new PublicProfileEntity({
      userId: dto.userId,
      _type: ProfileTypeOf,
      username: dto.username,
      firstname: dto.firstname,
      lastname: dto.lastname,
      biography: dto.biography,
      avatar: dto.avatar ? convertImageFromDto(dto.avatar) : null,
      birthDate: dto.birthdate ? new Date(dto.birthdate) : null,
      crossfitStartDate: dto.crossfitStartDate,
      genderCategory: dto.genderCategory,
      job: dto.job,
      nationality: dto.nationality,
      height: dto.height,
      weight: dto.weight,
      favoritesPersonalRecords: dto.favoritesPersonalRecords.map(FavoritePersonalRecordEntity.fromDto),
      ownedPrograms: dto.ownedPrograms.map(UserProgramItemEntity.fromDto),
      followedPrograms: dto.followedPrograms.map(UserProgramItemEntity.fromDto),
      followedProgramBundle: dto.followedProgramBundle.map(ProgramBundleItemEntity.fromDto),
      sharedCoachPrograms: dto.sharedCoachPrograms.map(UserProgramItemEntity.fromDto),
      badges: dto.badges.map(UserBadgeEntity.fromDto),
    })
  }
}
